import {FileUploadCancelTokenDetail} from 'Enrollment/models/FileUploadCancelTokenDetail';
import {EmptyEnrollmentFileRejectEmailHistoryFilter} from './../ducks/enrollmentFileProcessingReject';
import {BrokerSpreadsheetUploadsMetrics} from './../models/BrokerSpreadsheetsUploadsMetrics';
import {Async, Loaded, isLoaded, toPage} from './../../Core/models/Async';
import {Employer} from './../models/Employer';
import {createSnackbar} from 'Core/ducks/snackbar';
import {AsyncResult, fromResult, Loading, NotFound, ServerError, LoadingAdditional, Empty} from 'Core/models/Async';
import enrollmentFileApi from 'Enrollment/api/enrollmentFileApi';
import {
  changeEnrollmentApplications,
  changeEmployerProfileUploadDetails,
  changeEnrollmentFile,
  changeFileProfileMetrics,
  changeAccountProfileMetrics,
  changeFileTrackingMonitorMetrics,
  changeEnrollmentFileApplicationDetail,
  changeEnrollmentFileApplicationProcessingDetail,
  changeEnrollmentFiles,
  changeEnrollmentMetrics,
  changeFileFeedbackMetrics,
  changeFilesNotProcessedMetrics,
  changeIsFileUploading,
  EnrollmentFileActionType,
  enrollmentApplicationsFiltersEmpty,
  EnrollmentFileType,
  getEnrollmentFile,
  getEnrollmentFileApplicationDetail,
  getEnrollmentFileApplicationProcessingDetail,
  getEnrollmentFiles,
  uploadEnrollmentApplications,
  uploadEmployerProfiles,
  getEnrollmentApplications,
  getEmployerProfileUploadDetails,
  changeAllowedEnrollmentApplicationTemplates,
  getEnrollmentFileAWDHistoryDetail,
  changeEnrollmentFileAWDHistoryDetail,
  updateEnrollmentFileAuditStatus,
  changeAgreementAcknowledgment,
  getEnrollmentFileAuditDetail,
  changeEnrollmentFileAuditDetail,
  changeEnrollmentFileRecordValidationResult,
  getEnrollmentFileRecordValidationResult,
  changeLifeCycleReportChartDetails,
  changeProcessingAccuracyChartDetails,
  cancelExternalUploadQueue,
  cancelBrokerSpreadsheetUpload,
  changeDaysToCompleteTurnAroundChartDetails,
  changeTotalRecordsChartDetails,
  changeEnrollmentApplicationsDetail,
  getEnrollmentApplicationsDetail,
  getEnrollmentFileByCaseRequestId,
  getEnrollmentFileApplicationDetailById,
  changeEnrollmentFilesApplicationDetail,
  getExternalUploadQueue,
  changeExternalUploadQueue,
  getLifeCycleReportChartDetails,
  changeFileVolumeChartDetails,
  getFileVolumeChartDetail,
  changeEsrTotalRecordsChartDetails,
  getEsrTotalRecodsChartDetails,
  getProcessingAccuracyChartDetails,
  changeEmployers,
  changeFileUploadsInProgress,
  getEnrollmentErrorDetails,
  changeEnrollmentErrorDetails,
  changeBrokerSpreadsheetUploadMetrics,
  getApplications,
  changeApplications,
  cancelGenelcoUploadQueue,
  changeFileUploadCancelTokens,
  processBrokerSpreadsheet,
  changeAccountNumbers,
  changeProducts,
  getProducts,
  changeProcessAccuracyRecords,
  changeExternalUploadDetailsQueue,
  getExternalUploadDetailsQueue,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import {
  changeEnrollmentFileRejectApplication,
  changeEnrollmentFileRejectFileProfile,
  changeEnrollmentFileRejectNotes,
  changeEnrollmentFileRejects,
  changeEnrollmentFileRejectsEmail,
  EnrollmentFileRejectActionType,
  getEnrollmentFileRejectDetailApplications,
  getEnrollmentFileRejects,
  getEnrollmentFileRejectsEmail,
  sendEnrollmentFileRejectsEmail,
  deleteEnrollmentFileRejectError,
  getEnrollmentFileRejectByCaseRequestId,
  changeEnrollmentFileRejectDetail,
  getEnrollmentFileRejectsEmailHistory,
  changeEnrollmentFileRejectsEmailHistory,
  auditEnrollmentFileRejectsAttachmentDownload,
} from 'Enrollment/ducks/enrollmentFileProcessingReject';
import {
  changeEnrollmentFilesNotProcessed,
  changeFileAndScheduleHistoryStatus,
  EnrollmentFilesNotProcessedActionType,
  getEnrollmentFilesNotProcessed,
  getFileAndScheduleHistoryStatus,
} from 'Enrollment/ducks/enrollmentFilesNotProcessed';
import {pipe} from 'fp-ts/lib/pipeable';
import {EnrollmentFile} from 'Enrollment/models/EnrollmentFile';
import {EnrollmentFileReject} from 'Enrollment/models/EnrollmentFileReject';
import {EnrollmentFileRejectsGetEmail} from 'Enrollment/models/EnrollmentFileRejectsGetEmail';
import {EnrollmentFileRejectDetail} from 'Enrollment/models/EnrollmentFileRejectDetail';
import {EnrollmentApplication} from 'Enrollment/models/EnrollmentApplication';
import {EmployerProfileDetails} from 'Enrollment/models/EmployerProfileDetails';
import {ApplicationProcessingDetail} from 'Enrollment/models/ESRBPStatusDetails';
import {AWDHistoryDetail} from 'Enrollment/models/AWDStatusDetails';
import {EnrollmentFileNotes} from 'Enrollment/models/EnrollmentFileNotes';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, select, takeEvery, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {getApiCallGenerator, getPageApiCallGenerator, PageFetchAction} from 'Shared/utilities/sagaApiGenerators';
import {EnrollmentFileStatus, EnrollmentFilesNotProcessed} from '../models/EnrollmentFilesNotProcessed';
import {EnrollmentApplicationTemplate} from 'Enrollment/models/EnrollmentApplicationTemplate';
import {AgreementAcknowledgment} from 'Enrollment/models/AgreementAcknowledgment';
import {EnrollmentFileAuditDetail} from 'Enrollment/models/EnrollmentFileAuditDetail';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';
import {push} from 'connected-react-router';
import {EnrollmentFileRecordValidationResult} from 'Enrollment/models/EnrollmentFileRecordValidationResult';
import {LifeCycleReportChartDetailsPayload} from 'Enrollment/models/LifeCycleReportChartDetailsPayload';
import {ProcessingAccuracyChartDetailsPayload} from 'Enrollment/models/ProcessingAccuracyChartDetailsPayload';
import {DaysToCompleteTurnAroundChartDetailsPayload} from 'Enrollment/models/DaysToCompleteTurnAroundChartDetailsPayload';
import {EnrollmentFileApplicationDetail} from 'Enrollment/models/EnrollmentFileApplicationDetails';
import {TotalRecordsChartDetailsPayload} from 'Enrollment/models/TotalRecordsChartDetailsPayload';
import {EnrollmentFileDetails} from 'Enrollment/models/EnrollmentFileDetails';
import {ExternalUploadEnrollmentApplication} from 'Enrollment/models/ExternalUploadEnrollmentApplication';
import {Page} from 'Core/models/Page';
import {EnrollmentFileRejectApplication} from 'Enrollment/models/EnrollmentFileRejectApplication';
import {FileUploadInProgress} from 'Enrollment/models/FileUploadInProgress';
import {EnrollmentFileErrorDetails} from 'Enrollment/models/EnrollmentFileErrorDetails';
import {EnrollmentFileRejectEmailHistory} from 'Enrollment/models/EnrollmentFileRejectEmailHistory';
import {
  changeGenelcoBatchFile,
  GenelcoBatchFileActionType,
  getGenelcoBatchFile,
  reGenerateBatchFile,
  changeReGenerateBatchFile,
  reAuditBatchFile,
  changeReAuditBatchFile,
} from 'Enrollment/ducks/genelcoBatchFileManagement';
import {GenelcoBatchFile} from 'Enrollment/models/GenelcoBatchFile';

import {
  AccountProfileMetricsPayload,
  FileProfileMetricsPayload,
  FileTrackingMonitorMetricsPayload,
} from 'Enrollment/models/EnrollmentMetricsPayload';
import {Application} from 'Enrollment/models/Application';
import {ReducerState} from 'rootReducer';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';
import {AutoCompleteList} from 'Enrollment/models/AutoCompleteDto';
import { ExternalUploadEnrollmentApplicationDetails } from 'Enrollment/models/ExternalUploadEnrollmentApplicationDetails';

export function* fetchEnrollmentMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_ENROLLMENT_METRICS,
    getApiCallGenerator(enrollmentFileApi.getOverallEnrollmentMetrics, changeEnrollmentMetrics)
  );
}

export function* fetchFileFeedbackMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_FILEFEEDBACK_METRICS,
    getApiCallGenerator(enrollmentFileApi.getFileFeedbackMetrics, changeFileFeedbackMetrics)
  );
}

export function* fetchFilesNotProcessedMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_FILESNOTPROCESSED_METRICS,
    getApiCallGenerator(enrollmentFileApi.getFilesNotProcessedMetrics, changeFilesNotProcessedMetrics)
  );
}

export function* fetchFileProfileMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_FILE_PROFILE_METRICS,
    getFileProfileMetricsDetail
  );
}

export function* getFileProfileMetricsDetail() {
  const fileProfile: AsyncResult<FileProfileMetricsPayload> = yield call(
    enrollmentFileApi.getFileProfileMetrics
  );
  if (E.isRight(fileProfile)) {
    yield put(changeFileProfileMetrics(fromResult(fileProfile.right)));
  } else {
    yield put(changeFileProfileMetrics(new ServerError('Unable to fetch file profile metrics')));
  }
}

export function* fetchAccountProfileMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_ACCOUNT_PROFILE_METRICS,
    getAccountProfileMetricsDetail
  );
}

export function* getAccountProfileMetricsDetail() {
  const accountProfile: AsyncResult<AccountProfileMetricsPayload> = yield call(
    enrollmentFileApi.getAccountProfileMetrics
  );
  if (E.isRight(accountProfile)) {
    yield put(changeAccountProfileMetrics(fromResult(accountProfile.right)));
  } else {
    yield put(
      changeAccountProfileMetrics(new ServerError('Unable to fetch account profile metrics'))
    );
  }
}

export function* fetchFileTrackingMonitorMetricsSaga() {
  yield takeEvery(
    EnrollmentFileActionType.GET_FILE_TRACKING_MONITOR_METRICS,
    getFileTrackingMonitorMetricsDetail
  );
}

export function* getFileTrackingMonitorMetricsDetail() {
  const fileTrackingMonitor: AsyncResult<FileTrackingMonitorMetricsPayload> = yield call(
    enrollmentFileApi.getFileTrackingMonitorMetrics
  );
  if (E.isRight(fileTrackingMonitor)) {
    yield put(changeFileTrackingMonitorMetrics(fromResult(fileTrackingMonitor.right)));
  } else {
    yield put(
      changeFileTrackingMonitorMetrics(new ServerError('Unable to fetch file tracking monitor metrics'))
    );
  }
}

function* getEnrollmentFileRejectsFromApi(action: ReturnType<typeof getEnrollmentFileRejects>) {
  const {pageOption, filter, sort} = action.payload;

  if (pageOption) {
    yield put(changeEnrollmentFileRejects(new LoadingAdditional(pageOption)));
  } else {
    yield put(changeEnrollmentFileRejects(new Loading(pageOption)));
  }

  const result: AsyncResult<Page<EnrollmentFileReject>> = yield pageOption
    ? call(mergeWithNextPage, {existingPage: pageOption})
    : call(enrollmentFileApi.getEnrollmentFileRejects, filter, sort);

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeEnrollmentFileRejects(value)),
      value => put(changeEnrollmentFileRejects(value))
    )
  );
}

export const getEarnedCommissionsFromApi = (action: ReturnType<typeof getEnrollmentFilesNotProcessed>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentFilesNotProcessed>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentFilesNotProcessedReports(action.payload.filter);
    },
  })(action.payload);
};

export function* watchFetchFilesNotProcessedReport() {
  yield takeLatest(
    EnrollmentFilesNotProcessedActionType.GET_ENROLLMENT_FILES_NOT_PROCESSED,
    getPageApiCallGenerator(getEarnedCommissionsFromApi, changeEnrollmentFilesNotProcessed)
  );
}

export const getEnrollmentFilesFromApi = (action: ReturnType<typeof getEnrollmentFiles>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentFile>(additionalPage),
    Initial: () => {
      return action.payload.filter.fileType === EnrollmentFileType.EMW
        ? enrollmentFileApi.getEmwEnrollmentFiles(action.payload.filter)
        : enrollmentFileApi.getEsrEnrollmentFiles(action.payload.filter);
    },
  })(action.payload);
};

export function* watchUpdateEnrollmentFileRejectDetails() {
  yield takeLatest(
    EnrollmentFileRejectActionType.CHANGE_ENROLLMENT_FILE_REJECT_RECORDS,
    updateEnrollmentFileRejectDetailsSaga
  );
}

export function* updateEnrollmentFileRejectDetailsSaga(action: ReturnType<typeof deleteEnrollmentFileRejectError>) {
  const enrollmentFileRejectDetails: AsyncResult<string> = yield call(
    enrollmentFileApi.updateEnrollmentFileRejectDetails,
    action.payload.caseRequestId,
    action.payload.deleteReason
  );
  if (E.isRight(enrollmentFileRejectDetails)) {
    yield put(getEnrollmentFileRejects(undefined, action.payload.filter));
    yield put(createSnackbar('File Deleted Successfully'));
  } else {
    yield put(createSnackbar('Unable to Delete File'));
  }
}

export function* watchFetchEnrollmentFiles() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILES,
    getPageApiCallGenerator(getEnrollmentFilesFromApi, changeEnrollmentFiles)
  );
}

function* watchFetchEnrollmentFileRejects() {
  yield takeLatest(EnrollmentFileRejectActionType.GET_ENROLLMENT_FILE_REJECTS, getEnrollmentFileRejectsFromApi);
}

export function* getEnrollmentFileProfileIdSaga(fileName: string) {
  yield put(changeEnrollmentFileRejectFileProfile(new Loading()));
  const fileProfileId: AsyncResult<string> = yield call(enrollmentFileApi.getEnrollmentFileRejectFileProfile, fileName);

  if (E.isRight(fileProfileId)) {
    yield put(changeEnrollmentFileRejectFileProfile(fromResult(fileProfileId.right)));
  } else {
    yield put(changeEnrollmentFileRejectFileProfile(fileProfileId.left));
    if (!(fileProfileId.left instanceof NotFound)) {
      yield put(createSnackbar('Unable To Retrieve File Profile'));
    }
  }
}

function* getEnrollmentRejectionSaga(id: string, applicationSource: string) {
  const enrollmentFilesRejectDetail: AsyncResult<EnrollmentFileRejectDetail> = yield call(
    enrollmentFileApi.getEnrollmentFileRejectDetails,
    id,
    applicationSource
  );

  if (E.isRight(enrollmentFilesRejectDetail)) {
    yield put(changeEnrollmentFileRejectDetail(fromResult(enrollmentFilesRejectDetail.right)));
  } else {
    yield put(createSnackbar('Unable to load enrollment rejection details.'));
  }

  return enrollmentFilesRejectDetail;
}

export function* getEnrollmentFileNotesSaga(fileName: string) {
  const notes: AsyncResult<EnrollmentFileNotes[]> = yield call(enrollmentFileApi.getEnrollmentFileNotes, fileName);

  if (E.isRight(notes)) {
    yield put(changeEnrollmentFileRejectNotes(notes.right));
  } else {
    yield put(changeEnrollmentFileRejectNotes([]));
    yield put(createSnackbar('Unable to Load File Profile Notes'));
  }
}

const getEnrollmentFileRejectFromApi = (action: ReturnType<typeof getEnrollmentFileRejectDetailApplications>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentFileRejectApplication>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentFileRejectDetailsApplications(
        action.routeParameters[0] as string,
        action.routeParameters[1] as string,
        action.payload.filter,
        action.routeParameters[2] as Sort
      );
    },
  })(action.payload);
};

const getEnrollmentFileRejectEmailHistoryFromApi = (
  action: ReturnType<typeof getEnrollmentFileRejectsEmailHistory>
) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentFileRejectEmailHistory>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentFileRejectEmailHistory(
        action.routeParameters[0] as string,
        action.routeParameters[1] as string,
        action.payload.filter
      );
    },
  })(action.payload);
};

function* getEnrollmentFileRejectByCaseRequestIdFromApi(
  action: ReturnType<typeof getEnrollmentFileRejectByCaseRequestId>
) {
  const {id, applicationSource} = action.payload;
  
  const result: AsyncResult<EnrollmentFileRejectDetail> = yield getEnrollmentRejectionSaga(id, applicationSource);

  if (E.isRight(result)) {
    const {fileName} = result.right;

    yield all([getEnrollmentFileNotesSaga(fileName!), getEnrollmentFileProfileIdSaga(fileName!)]);
  }
}

export function* watchFetchEnrollmentFileRejectByCaseRequestId() {
  yield takeLatest(
    EnrollmentFileRejectActionType.GET_ENROLLMENT_FILE_REJECT_BY_CASE_REQUEST_ID,
    getEnrollmentFileRejectByCaseRequestIdFromApi
  );
}

export function* watchFetchEnrollmentFileRejectDetails() {
  yield takeLatest(
    EnrollmentFileRejectActionType.GET_ENROLLMENT_FILE_REJECT_DETAIL_APPLICATIONS,
    getPageApiCallGenerator(getEnrollmentFileRejectFromApi, changeEnrollmentFileRejectApplication)
  );
}

export function* watchFetchEnrollmentFileRejecEmailHistory() {
  yield takeLatest(
    EnrollmentFileRejectActionType.GET_ENROLLMENT_FILE_REJECTS_EMAIL_HISTORY,
    getPageApiCallGenerator(getEnrollmentFileRejectEmailHistoryFromApi, changeEnrollmentFileRejectsEmailHistory)
  );
}

export function* watchFetchGetEnrollmentFileRejectsEmail() {
  yield takeLatest(
    EnrollmentFileRejectActionType.GET_ENROLLMENT_FILE_REJECTS_EMAIL,
    getEnrollmentFileRejectsEmailTemplate
  );
}

export function* watchFetchSendEnrollmentFileRejectsEmail() {
  yield takeLatest(
    EnrollmentFileRejectActionType.SEND_ENROLLMENT_FILE_REJECTS_EMAIL,
    sendEnrollmentFileRejectsDetailEmail
  );
}

export function* watchAuditEnrollmentFileRejectsAttachmentDownload() {
  yield takeLatest(
    EnrollmentFileRejectActionType.AUDIT_ENROLLMENT_FILE_REJECTS_EMAIL_ATTACHMENT_DOWNLOAD,
    auditEnrollmentFileRejectsAttachmentDownloadSaga
  );
}

export function* auditEnrollmentFileRejectsAttachmentDownloadSaga(action: ReturnType<typeof auditEnrollmentFileRejectsAttachmentDownload>) {
  const auditEnrollmentFilesRejectsEmailAttachmentDownloadResult: AsyncResult<string>  = yield call(
    enrollmentFileApi.auditEnrollmentFileRejectsEmailAttachmentDownload, 
    action.payload.caseRequestID!
  );

  if (E.isRight(auditEnrollmentFilesRejectsEmailAttachmentDownloadResult)) {
    const fileName = `${action.payload.attachmentName}`;
    const linkSource = `data:application/vnd.ms-excel;base64,${action.payload.attachment!}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  else {
    yield put(createSnackbar('Unable to download the attachment'));
  }
}

export function* getEnrollmentFileRejectsEmailTemplate(action: ReturnType<typeof getEnrollmentFileRejectsEmail>) {
  const enrollmentFilesRejectsEmail: AsyncResult<EnrollmentFileRejectsGetEmail> = yield call(
    enrollmentFileApi.getEnrollmentFileRejectsEmail,
    action.payload.rejectFile
  );
  if (E.isRight(enrollmentFilesRejectsEmail)) {
    yield put(changeEnrollmentFileRejectsEmail(fromResult(enrollmentFilesRejectsEmail.right)));
  }
}

export function* sendEnrollmentFileRejectsDetailEmail(action: ReturnType<typeof sendEnrollmentFileRejectsEmail>) {
  const {payload} = action;
  const {email} = payload;
  const sendEnrollmentFilesRejectsEmail: AsyncResult<string> = yield call(
    enrollmentFileApi.sendEnrollmentFileRejectsEmail,
    email
  );
  if (E.isRight(sendEnrollmentFilesRejectsEmail)) {
    yield put(createSnackbar(`A File Error Report for ${email.accountNumber!} was sent.`));
    if (email.isResend) {
      const applicationSource = email.caseRequestId ? "ESR" : "GenelcoSpreadsheet";
      const id = applicationSource === "ESR" ? email.caseRequestId! : email.fileId!
      yield put(
        getEnrollmentFileRejectsEmailHistory(
          id!,
          applicationSource!,
          undefined,
          EmptyEnrollmentFileRejectEmailHistoryFilter
        )
      );
      yield put(push(`${EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS_EMAIL_HISTORY(id!, applicationSource!)}`));
    } else {
      yield put(push(`${EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS}?emailStatus=Unsent`));
    }
  }

  payload.onSuccess();
}

export const getEnrollmentFileFromApi = (action: ReturnType<typeof getEnrollmentFile>) =>
  action.payload.isEMW
    ? enrollmentFileApi.getEmwEnrollmentFileDetails(action.payload.enrollmentFileId)
    : enrollmentFileApi.getEsrEnrollmentFileDetails(action.payload.enrollmentFileId);

export function* watchFetchEnrollmentFileDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILE,
    getApiCallGenerator(getEnrollmentFileFromApi, changeEnrollmentFile)
  );
}

const getEnrollmentFileApplicationDetails = (action: ReturnType<typeof getEnrollmentFileApplicationDetail>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentFileApplicationDetail>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentFileApplicationDetail(action.payload.filter);
    },
  })(action.payload);
};

function* watchFetchEnrollmentFileApplicationDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILES_APPLICATION_DETAILS,
    getPageApiCallGenerator(getEnrollmentFileApplicationDetails, changeEnrollmentFileApplicationDetail)
  );
}

export function* getEnrollmentFileStatus(action: ReturnType<typeof getFileAndScheduleHistoryStatus>) {
  const fileScheduleHistoryStatus: AsyncResult<EnrollmentFileStatus> = yield call(
    enrollmentFileApi.getFileAndScheduleHistoryStatus,
    action.payload.data
  );
  if (E.isRight(fileScheduleHistoryStatus)) {
    yield put(changeFileAndScheduleHistoryStatus(fromResult(fileScheduleHistoryStatus.right)));
  } else {
    yield put(createSnackbar('Unable to Fetch File History Data'));
  }
}

export function* watchFetchGetEnrollmentFileStatus() {
  yield takeLatest(EnrollmentFilesNotProcessedActionType.GET_ENROLLMENT_FILE_STATUS, getEnrollmentFileStatus);
}

export function* uploadEnrollmentApps(action: ReturnType<typeof uploadEnrollmentApplications>) {
  const {payload} = action;
  const {file, applicationTypeId, fileInUploadProgressId, id, groupId, fileId, cancelTokenSource} = payload;

  const result: AsyncResult<any> = yield call(
    enrollmentFileApi.uploadEnrollmentApplications,
    file,
    applicationTypeId,
    fileInUploadProgressId,
    cancelTokenSource,
    id,
    groupId
  );

  if (E.isRight(result)) {
    yield put(changeEnrollmentApplications(new Empty()));
    const fileUploadsInProgress: Async<FileUploadInProgress[]> = yield select(
      (state: ReducerState) => state.enrollmentFileProcessing.fileUploadsInProgress
    );
    if (isLoaded(fileUploadsInProgress)) {
      const newFileUploadsInProgress = fileUploadsInProgress.Data.filter(x => x.id !== fileInUploadProgressId);
      yield put(changeFileUploadsInProgress(fromResult(newFileUploadsInProgress)));
    }
    yield all([getEnrollmentApplicationSaga(), getFileUploadsInProgressSaga()]);
    if (groupId) yield put(getEnrollmentApplicationsDetail(fileId!));
    if (fromResult(result.right).Data.content instanceof Array) {
      const uploadEnrollmentErrors: string[] = fromResult(result.right).Data.content;
      const possibleEnrollmentSheetNotAvailableErrors: string[] = [
        'Employee Details Sheet Not Available',
        'Dependent Details Sheet Not Available',
      ];
      if (possibleEnrollmentSheetNotAvailableErrors.some(x => uploadEnrollmentErrors.includes(x))) {
        yield put(createSnackbar('Unable to Upload File'));
      }
    } else {
      const uploadEnrollmentApp: EnrollmentApplication = fromResult(result.right).Data.content;
      if (uploadEnrollmentApp!.rowCount! === 0) yield put(createSnackbar('No Employee Enrollments Found on File'));
      else {
        yield put(createSnackbar('File Upload Successful'));
      }
    }
  } else {
    yield put(changeIsFileUploading(false));
    var {fileUploadCancelTokens} = yield select((state: ReducerState) => state.enrollmentFileProcessing);
    const fileUploadCancelled = (fileUploadCancelTokens as FileUploadCancelTokenDetail[]).find(
      x => x.fileId === fileInUploadProgressId
    )?.isCancel;

    if (!fileUploadCancelled) {
      yield put(createSnackbar('Unable to Upload File'));
    }
  }
}

export function* uploadEnrollmentEmployerProfiles(action: ReturnType<typeof uploadEmployerProfiles>) {
  const {payload} = action;
  const {file} = payload;
  const result: AsyncResult<any> = yield call(enrollmentFileApi.uploadEmployerProfiles, file);
  if (E.isRight(result)) {
    yield put(changeEmployerProfileUploadDetails(new Empty()));
    yield all([getEmployerProfileSaga()]);
    yield put(createSnackbar('File Upload Successful'));
  } else {
    yield put(createSnackbar('Unable to Upload File'));
  }
}

export function* watchFetchUploadEnrollmentApplications() {
  yield takeLatest(EnrollmentFileActionType.UPLOAD_ENROLLMENT_FILE_APPLICATIONS, uploadEnrollmentApps);
}

export function* watchUploadEmployerProfiles() {
  yield takeLatest(EnrollmentFileActionType.UPLOAD_ENROLLMENT_EMPLOYER_PROFILES, uploadEnrollmentEmployerProfiles);
}

export function* getEnrollmentFileApplicationProcessingDetails(
  action: ReturnType<typeof getEnrollmentFileApplicationProcessingDetail>
) {
  const applicationProcessingDetails: AsyncResult<ApplicationProcessingDetail[]> = yield call(
    enrollmentFileApi.getEnrollmentFileApplicationProcessingDetail,
    action.payload.id
  );
  if (E.isRight(applicationProcessingDetails)) {
    yield put(changeEnrollmentFileApplicationProcessingDetail(fromResult(applicationProcessingDetails.right)));
  } else {
    yield put(
      changeEnrollmentFileApplicationProcessingDetail(
        new ServerError('Unable to retrieve processing details at this time.')
      )
    );
  }
}
export function* watchFetchEnrollmentFileApplicationProcessingDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILES_APPLICATION_PROCESSING_DETAILS,
    getEnrollmentFileApplicationProcessingDetails
  );
}
export const getEnrollmentApplicationsFileMetaData = (action: ReturnType<typeof getEnrollmentApplications>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EnrollmentApplication>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentApplications(action.payload.filter, action.routeParameters[0] as Sort);
    },
  })(action.payload);
};
export const getEmployerProfileUploadedFileData = (action: ReturnType<typeof getEmployerProfileUploadDetails>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EmployerProfileDetails>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEmployerProfileUploadDetails(
        action.payload.filter,
        action.routeParameters[0] as Sort
      );
    },
  })(action.payload);
};
export function* getEnrollmentApplicationSaga() {
  const enrollmentApplications: AsyncResult<Page<EnrollmentApplication>> = yield call(
    enrollmentFileApi.getEnrollmentApplications
  );
  yield put(
    pipe(
      enrollmentApplications,
      E.map(r => new Loaded(r)),
      E.fold(changeEnrollmentApplications, changeEnrollmentApplications)
    )
  );
}
export function* getEmployerProfileSaga() {
  const employerProfile: AsyncResult<Page<EmployerProfileDetails>> = yield call(
    enrollmentFileApi.getEmployerProfileUploadDetails
  );
  yield put(
    pipe(
      employerProfile,
      E.map(r => new Loaded(r)),
      E.fold(changeEmployerProfileUploadDetails, changeEmployerProfileUploadDetails)
    )
  );
}

export const getExternalUploadsQueue = (action: ReturnType<typeof getExternalUploadQueue>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<ExternalUploadEnrollmentApplication>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getExternalUploadQueue(action.payload.filter);
    },
  })(action.payload);
};
export function* watchFetchGetExternalUploadQueue() {
  yield takeLatest(
    EnrollmentFileActionType.GET_EXTERNAL_UPLOAD_QUEUE,
    getPageApiCallGenerator(getExternalUploadsQueue, changeExternalUploadQueue)
  );
}
export function* watchFetchEnrollmentFileAWDHistoryDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILES_AWD_HISTORY_DETAILS,
    getEnrollmentFileAWDHistoryDetails
  );
}

export function* getEnrollmentFileAWDHistoryDetails(action: ReturnType<typeof getEnrollmentFileAWDHistoryDetail>) {
  const AWDHistoryDetails: AsyncResult<AWDHistoryDetail> = yield call(
    enrollmentFileApi.getEnrollmentFileAWDHistoryDetail,
    action.payload.id
  );
  if (E.isRight(AWDHistoryDetails)) {
    yield put(changeEnrollmentFileAWDHistoryDetail(fromResult(AWDHistoryDetails.right)));
  } else {
    yield put(
      changeEnrollmentFileAWDHistoryDetail(new ServerError('Unable to retrieve processing details at this time.'))
    );
  }
}

export function* watchFetchGetEnrollmentApplicationsMetaData() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_APPLICATIONS,
    getPageApiCallGenerator(getEnrollmentApplicationsFileMetaData, changeEnrollmentApplications)
  );
}

export function* watchFetchGetEmployerProfileUploadData() {
  yield takeLatest(
    EnrollmentFileActionType.GET_EMPLOYER_PROFILE_DETAILS,
    getPageApiCallGenerator(getEmployerProfileUploadedFileData, changeEmployerProfileUploadDetails)
  );
}

export function* getAllowedEnrollmentApplicationTemplate() {
  const allowedTemplates: AsyncResult<EnrollmentApplicationTemplate[]> = yield call(
    enrollmentFileApi.getAllowedEnrollmentApplicationTemplates
  );
  if (E.isRight(allowedTemplates)) {
    yield put(changeAllowedEnrollmentApplicationTemplates(fromResult(allowedTemplates.right)));
  } else {
    yield put(changeAllowedEnrollmentApplicationTemplates(new ServerError('Unable to retrieve allowed template')));
    yield put(createSnackbar('unable to retrieve allowed templates'));
  }
}

export function* watchGetAllowedEnrollmentApplicationTemplates() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_APPLICATION_TEMPLATE,
    getAllowedEnrollmentApplicationTemplate
  );
}

export function* updateEnrollmentFileAudit(action: ReturnType<typeof updateEnrollmentFileAuditStatus>) {
  const enrollmentFileAudit: AsyncResult<EnrollmentApplication> = yield call(
    enrollmentFileApi.updateEnrollmentFileAuditStatus,
    action.payload.fileId
  );
  if (E.isRight(enrollmentFileAudit)) {
    yield put(getEnrollmentApplications(undefined, enrollmentApplicationsFiltersEmpty));
    yield put(changeIsFileUploading(false));
    yield put(createSnackbar('File Audit Initiated Successfully'));
  } else {
    yield put(createSnackbar('Unable to Initiate File Audit'));
  }
}

export function* getEnrollmentFileAuditDetails(action: ReturnType<typeof getEnrollmentFileAuditDetail>) {
  const enrollmentFileAuditDetail: AsyncResult<EnrollmentFileAuditDetail> = yield call(
    enrollmentFileApi.getEnrollmentFileAuditDetail,
    action.payload.fileId
  );
  if (E.isRight(enrollmentFileAuditDetail)) {
    yield put(changeEnrollmentFileAuditDetail(fromResult(enrollmentFileAuditDetail.right)));
  } else {
    yield put(createSnackbar('Unable to retrieve File Audit Details'));
  }
}

export function* watchsaveUsersAgreementAcknowledgment() {
  yield takeLatest(
    EnrollmentFileActionType.SAVE_FILE_UPLOAD_AGREEMENT_ACKNOWLEDGMENT,
    saveUsersAgreementAcknowledgment
  );
}
export function* saveUsersAgreementAcknowledgment() {
  const agreementData: AsyncResult<AgreementAcknowledgment> = yield call(enrollmentFileApi.saveAgreementAcknowledgment);
  if (E.isRight(agreementData)) {
    yield put(changeAgreementAcknowledgment(fromResult(agreementData.right)));
  } else {
    yield put(changeAgreementAcknowledgment(new ServerError('Unable to save acknowledgment')));
    yield put(createSnackbar('Unable to Save Acknowledgment'));
  }
}
export function* watchFetchGetEnrollmentFileAudit() {
  yield takeLatest(EnrollmentFileActionType.UPDATE_ENROLLMENT_FILE_AUDIT_STATUS, updateEnrollmentFileAudit);
}

export function* watchFetchGetEnrollmentFileAuditDetail() {
  yield takeLatest(EnrollmentFileActionType.GET_ENROLLMENT_FILE_AUDIT_DETAIL, getEnrollmentFileAuditDetails);
}
export function* watchGetEnrollmentFileRecordValidation() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILE_RECORD_VALIDATION_RESULT,
    getEnrollmentFileRecordValidation
  );
}
export function* getEnrollmentFileRecordValidation(action: ReturnType<typeof getEnrollmentFileRecordValidationResult>) {
  const validationResult: AsyncResult<EnrollmentFileRecordValidationResult> = yield call(
    enrollmentFileApi.getEnrollmentFileRecordValidationResult,
    action.payload.fileId
  );
  if (E.isRight(validationResult)) {
    yield put(changeEnrollmentFileRecordValidationResult(fromResult(validationResult.right)));
  } else {
    yield put(createSnackbar('Unable to Validate File'));
  }
}

export function* watchFetchGetLifeCycleReportChartDetails() {
  yield takeLatest(EnrollmentFileActionType.GET_LIFE_CYCLE_REPORT_CHART_DETAILS, getLifeCycleReportChartDetail);
}
export function* getLifeCycleReportChartDetail(action: ReturnType<typeof getLifeCycleReportChartDetails>) {
  const lifeCycleReportChartDetails: AsyncResult<LifeCycleReportChartDetailsPayload> = yield call(
    enrollmentFileApi.getLifeCycleReportChartDetail,
    action.payload.chartType
  );
  if (E.isRight(lifeCycleReportChartDetails)) {
    yield put(changeLifeCycleReportChartDetails(fromResult(lifeCycleReportChartDetails.right)));
  } else {
    yield put(
      changeLifeCycleReportChartDetails(new ServerError('Unable to retrieve life cycle report chart details.'))
    );
  }
}
function* watchFetchProcessingAccuracyChartDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_PROCESSING_ACCURACY_CHART_DETAILS,
    getProcessingAccuracyChartDetailsSaga
  );
}

function* getProcessingAccuracyChartDetailsSaga(action: ReturnType<typeof getProcessingAccuracyChartDetails>) {
  const processingAccuracyChartDetails: AsyncResult<ProcessingAccuracyChartDetailsPayload[]> = yield call(
    enrollmentFileApi.getProcessingAccuracyChartDetails,
    action.payload.employerName,
    action.payload.agentNumbers,
    action.payload.isNewYork,
    action.payload.encryptedIdentifier,
    action.payload.caseNumbers,
    action.payload.productType,
    action.payload.startdate,
    action.payload.endDate
  );
  if (E.isRight(processingAccuracyChartDetails)) {
    yield put(changeProcessingAccuracyChartDetails(fromResult(processingAccuracyChartDetails.right)));
    yield put(changeProcessAccuracyRecords(true));
  } else {
    yield put(
      changeProcessingAccuracyChartDetails(new ServerError('Unable to retrieve life cycle report chart details.'))
    );
    yield put(changeProcessAccuracyRecords(true));
  }
}

export function* watchUpdateEnrollmentFileStatus() {
  yield takeLatest(EnrollmentFileActionType.CHANGE_EXTERNAL_ENROLLMENT_FILES, updateEnrollmentFileStatusSaga);
}

export function* watchBrokerSpreadsheetCancelStatus() {
  yield takeLatest(EnrollmentFileActionType.CHANGE_BROKER_SPREADSHEET_CANCEL, updateBrokerSpreadsheetCancelStatusSaga);
}

export function* updateEnrollmentFileStatusSaga(action: ReturnType<typeof cancelExternalUploadQueue>) {
  const enrollmentFileStatus: AsyncResult<string> = yield call(
    enrollmentFileApi.updateEnrollmentFileStatus,
    action.payload.fileId,
    action.payload.fileStatusId,
    action.payload.removalReasonId,
    action.payload.returnComments,
    action.payload.uploadedByEmail,
    action.payload.actionBy,
  );
  if (E.isRight(enrollmentFileStatus)) {
    yield put(getExternalUploadQueue(undefined, action.payload.filter));
    yield put(createSnackbar('File Status Updated Successfully'));
  } else {
    yield put(createSnackbar('Unable to Update File Status'));
  }
}

export function* updateBrokerSpreadsheetCancelStatusSaga(action: ReturnType<typeof cancelBrokerSpreadsheetUpload>) {
  const enrollmentFileStatus: AsyncResult<string> = yield call(
    enrollmentFileApi.updateBrokerSpreadsheetCancelStatus,
    action.payload.fileId,
    action.payload.fileStatusId,
    action.payload.removalReasonId
  );
  if (E.isRight(enrollmentFileStatus)) {
    yield put(getEnrollmentApplications(undefined, enrollmentApplicationsFiltersEmpty));
    yield put(getEnrollmentApplicationsDetail(action.payload.fileId));
    yield put(createSnackbar('File Status Updated Successfully'));
  } else {
    yield put(createSnackbar('Unable to Update File Status'));
  }
}

export function* watchFetchGetTotalRecordsChartDetails() {
  yield takeLatest(EnrollmentFileActionType.GET_TOTAL_RECORDS_CHART_DETAILS, getTotalRecordsChartDetails);
}
export function* getTotalRecordsChartDetails() {
  const totalRecordsChartDetails: AsyncResult<TotalRecordsChartDetailsPayload[]> = yield call(
    enrollmentFileApi.getTotalRecordsChartDetails
  );
  if (E.isRight(totalRecordsChartDetails)) {
    yield put(changeTotalRecordsChartDetails(fromResult(totalRecordsChartDetails.right)));
  } else {
    yield put(changeTotalRecordsChartDetails(new ServerError('Unable to retrieve total records chart details.')));
  }
}

export function* watchFetchDaysToCompleteTurnAroundChartDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_DAYS_TO_COMPLETE_TURN_AROUND_CHART_DETAILS,
    getDaysToCompleteTurnAroundChartDetails
  );
}
export function* getDaysToCompleteTurnAroundChartDetails() {
  const completeTurnAroundChartDetails: AsyncResult<DaysToCompleteTurnAroundChartDetailsPayload[]> = yield call(
    enrollmentFileApi.getDaysToCompleteTurnAroundChartDetails
  );
  if (E.isRight(completeTurnAroundChartDetails)) {
    yield put(changeDaysToCompleteTurnAroundChartDetails(fromResult(completeTurnAroundChartDetails.right)));
  } else {
    yield put(
      changeDaysToCompleteTurnAroundChartDetails(
        new ServerError('Unable to retrieve days to complete turn around chart details.')
      )
    );
  }
}
export function* watchFetchgetEnrollmentFileDetailsByCaseRequestId() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_FILE_By_CASE_REQUEST_ID,
    getEnrollmentFileDetailsByCaseRequestId
  );
}
export function* getEnrollmentFileDetailsByCaseRequestId(action: ReturnType<typeof getEnrollmentFileByCaseRequestId>) {
  const enrollmentFileDetails: AsyncResult<EnrollmentFileDetails> = yield call(
    enrollmentFileApi.getEsrEnrollmentFileDetailsByCaseRequestId,
    action.payload.caseRequestId
  );
  if (E.isRight(enrollmentFileDetails)) {
    yield put(changeEnrollmentFile(fromResult(enrollmentFileDetails.right)));
  } else {
    yield put(changeEnrollmentFile(new ServerError('Unable to retrieve enrollment file detail.')));
  }
}
export function* watchFetchgetEnrollmentFileApplicationDetail() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_File_APPLICATION_DETAIL,
    getEnrollmentFileApplicationDetailByRequestId
  );
}
export function* getEnrollmentFileApplicationDetailByRequestId(
  action: ReturnType<typeof getEnrollmentFileApplicationDetailById>
) {
  const enrollmentFileApplicationDetail: AsyncResult<EnrollmentFileApplicationDetail> = yield call(
    enrollmentFileApi.getEnrollmentFileApplicationDetailById,
    action.payload.requestId,
    action.payload.caseRequestId
  );
  if (E.isRight(enrollmentFileApplicationDetail)) {
    yield put(changeEnrollmentFilesApplicationDetail(fromResult(enrollmentFileApplicationDetail.right)));
  } else {
    yield put(
      changeEnrollmentFilesApplicationDetail(new ServerError('Unable to retrieve enrollment file application detail.'))
    );
  }
}

export const getEnrollmentApplicationsDetails = (action: ReturnType<typeof getEnrollmentApplicationsDetail>) =>
  enrollmentFileApi.getEnrollmentApplicationsDetail(action.payload.id);

export function* watchFetchGetEnrollmentApplicationsDetails() {
  yield takeLatest(
    EnrollmentFileActionType.GET_ENROLLMENT_APPLICATIONS_DETAIL,
    getApiCallGenerator(getEnrollmentApplicationsDetails, changeEnrollmentApplicationsDetail)
  );
}

export function* getEnrollmentFileErrorDetails(action: ReturnType<typeof getEnrollmentErrorDetails>) {
  const result: AsyncResult<EnrollmentFileErrorDetails[]> = yield call(
    enrollmentFileApi.getEnrollmentFileErrorDetails,
    action.payload.filter!,
    action.payload.sort
  );
  if (E.isRight(result)) {
    yield put(changeEnrollmentErrorDetails(fromResult(toPage(result.right))));
  } else {
    yield put(changeEnrollmentErrorDetails(new ServerError('Unable to retrieve enrollment file error details.')));
  }
}
export function* watchFetchGetEnrollmentFileErrorDetails() {
  yield takeLatest(EnrollmentFileActionType.GET_ENROLLMENT_ERROR_DETAILS, getEnrollmentFileErrorDetails);
}

export function* watchFetchGetFileVolumeChartDetails() {
  yield takeLatest(EnrollmentFileActionType.GET_FILE_VOLUME_CHART_DETAILS, getFileVolumeChartDetails);
}
export function* getFileVolumeChartDetails(action: ReturnType<typeof getFileVolumeChartDetail>) {
  const fileVolumeChartDetails: AsyncResult<LifeCycleReportChartDetailsPayload> = yield call(
    enrollmentFileApi.getFileVolumChartDetails,
    action.payload.chartType,
    action.payload.employerName
  );
  if (E.isRight(fileVolumeChartDetails)) {
    yield put(changeFileVolumeChartDetails(fromResult(fileVolumeChartDetails.right)));
  } else {
    yield put(changeFileVolumeChartDetails(new ServerError('Unable to retrieve file volume details.')));
  }
}
export function* watchFetchGetEsrTotalRecordsChartDetails() {
  yield takeLatest(EnrollmentFileActionType.GET_ESR_TOTAL_RECORDS, getEsrTotalRecordsChartDetails);
}
export function* getEsrTotalRecordsChartDetails(action: ReturnType<typeof getEsrTotalRecodsChartDetails>) {
  const totalRecords: AsyncResult<TotalRecordsChartDetailsPayload[]> = yield call(
    enrollmentFileApi.getEsrTotalRecordsChartDetails,
    action.payload.employerName
  );
  if (E.isRight(totalRecords)) {
    yield put(changeEsrTotalRecordsChartDetails(fromResult(totalRecords.right)));
  } else {
    yield put(changeEsrTotalRecordsChartDetails(new ServerError('Unable to retrieve total records details.')));
  }
}
export function* watchFetchGetEmployers() {
  yield takeLatest(EnrollmentFileActionType.GET_EMPLOYERS, getEmployersSaga);
}
export function* getEmployersSaga() {
  const employers: AsyncResult<Employer[]> = yield call(enrollmentFileApi.getEmployers);
  if (E.isRight(employers)) {
    yield put(changeEmployers(fromResult(employers.right)));
  } else {
    yield put(changeEmployers(new ServerError('Unable to retrieve employers.')));
  }
}

export function* watchFetchGetFileUploadsInProgress() {
  yield takeLatest(EnrollmentFileActionType.GET_FILE_UPLOADS_IN_PROGRESS, getFileUploadsInProgressSaga);
}

export function* getFileUploadsInProgressSaga() {
  const latestFileUploadsInProgress: AsyncResult<FileUploadInProgress[]> = yield call(
    enrollmentFileApi.getFileUploadsInProgress
  );
  if (E.isRight(latestFileUploadsInProgress)) {
    const fileUploadCancelTokens: FileUploadCancelTokenDetail[] = yield select(
      (state: ReducerState) => state.enrollmentFileProcessing.fileUploadCancelTokens
    );
    latestFileUploadsInProgress.right.map(fileUploadInProgress => {
      const fileUploadCancelTokenDetail = fileUploadCancelTokens.find(x => x.fileId === fileUploadInProgress.id);
      if (fileUploadCancelTokenDetail) {
        fileUploadCancelTokenDetail.isProcessingByServer = true;
      }
    });
    yield put(changeFileUploadCancelTokens(fileUploadCancelTokens));
    const activeFileUploads = fileUploadCancelTokens
      .filter(x => !x.isCancel && !x.isProcessingByServer)
      .map(x => x.fileId);
    let updatedfileUploadsInProgress: FileUploadInProgress[] = [...latestFileUploadsInProgress.right];

    const fileUploadsInProgress: Async<FileUploadInProgress[]> = yield select(
      (state: ReducerState) => state.enrollmentFileProcessing.fileUploadsInProgress
    );
    const latestFileUploadsIds = latestFileUploadsInProgress.right.map(x => x.id);
    isLoaded(fileUploadsInProgress) &&
      fileUploadsInProgress.Data.map(fileUploadInProgress => {
        if (
          activeFileUploads.includes(fileUploadInProgress.id!) &&
          !latestFileUploadsIds.includes(fileUploadInProgress.id)
        ) {
          updatedfileUploadsInProgress = [...latestFileUploadsInProgress.right, {...fileUploadInProgress}];
        }
        return fileUploadInProgress;
      });
    yield put(changeFileUploadsInProgress(fromResult(updatedfileUploadsInProgress)));
  } else {
    yield put(changeFileUploadsInProgress(new ServerError('Unable to retrieve files in upload progress.')));
  }
}
export function* watchFetchgetBrokerSpreadsheetUploadsMetricsSaga() {
  yield takeLatest(
    EnrollmentFileActionType.GET_BROKER_SPREADSHEET_UPLOADS_METRICS,
    getBrokerSpreadsheetUploadsMetricsSaga
  );
}
export function* getBrokerSpreadsheetUploadsMetricsSaga() {
  const brokerSpreadsheetUploads: AsyncResult<BrokerSpreadsheetUploadsMetrics> = yield call(
    enrollmentFileApi.getBrokerSpreadsheetUploadsMetrics
  );

  if (E.isRight(brokerSpreadsheetUploads)) {
    yield put(changeBrokerSpreadsheetUploadMetrics(fromResult(brokerSpreadsheetUploads.right)));
  } else {
    yield put(
      changeBrokerSpreadsheetUploadMetrics(new ServerError('Unable to retrieve broker spreadsheet uploads metrics'))
    );
  }
}

export function* watchFetchgetApplications() {
  yield takeLatest(EnrollmentFileActionType.GET_APPLICATIONS, getApplicationsSaga);
}
export function* getApplicationsSaga(action: ReturnType<typeof getApplications>) {
  const applications: AsyncResult<Application[]> = yield call(
    enrollmentFileApi.getApplications,
    action.payload.filters,
    action.payload.sort
  );

  if (E.isRight(applications)) {
    yield put(changeApplications(fromResult(applications.right)));
  } else {
    yield put(changeApplications(new ServerError('Unable to retrieve  applications')));
  }
}

export function* watchUpdateEnrollmentFileGenelcoStatus() {
  yield takeLatest(EnrollmentFileActionType.CHANGE_GENELCO_ENROLLMENT_FILES, updateEnrollmentFileGenelcoStatusSaga);
}

export function* updateEnrollmentFileGenelcoStatusSaga(action: ReturnType<typeof cancelGenelcoUploadQueue>) {
  const enrollmentFileStatus: AsyncResult<string> = yield call(
    enrollmentFileApi.updateEnrollmentFileStatus,
    action.payload.fileId,
    action.payload.fileStatusId,
    action.payload.removalReasonId
  );
  if (E.isRight(enrollmentFileStatus)) {
    yield put(getEnrollmentApplications(undefined, action.payload.filter));
    yield put(getEnrollmentApplicationsDetail(action.payload.fileId));
    yield put(createSnackbar('File Status Updated Successfully'));
  } else {
    yield put(createSnackbar('Unable to Update File Status'));
  }
}

export const getGenelcoBatchFilesData = (action: ReturnType<typeof getGenelcoBatchFile>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<GenelcoBatchFile>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getGenelcoBatchFile(action.payload.filter, action.routeParameters[0] as Sort);
    },
  })(action.payload);
};

export function* watchFetchGenelcoBatchFile() {
  yield takeLatest(
    GenelcoBatchFileActionType.GET_GENELCO_BATCH_FILES,
    getPageApiCallGenerator(getGenelcoBatchFilesData, changeGenelcoBatchFile)
  );
}

export function* watchBatchFileGenerationStatus() {
  yield takeLatest(GenelcoBatchFileActionType.REGENERATE_BATCH_FILE, reGenerateBatchFileSaga);
}

export function* reGenerateBatchFileSaga(action: ReturnType<typeof reGenerateBatchFile>) {
  var {isBatchRegenerationCompleted} = yield select((state: ReducerState) => state.genelcoBatchFileManagementState);
  isBatchRegenerationCompleted.push(action.payload.processingCompletedDate);
  yield put(changeReGenerateBatchFile(isBatchRegenerationCompleted));
  const reGenerationStatus: AsyncResult<boolean> = yield call(
    enrollmentFileApi.reGenerateBatchFile,
    action.payload.processingCompletedDate
  );

  if (E.isRight(reGenerationStatus)) {
    yield put(getGenelcoBatchFile(undefined, action.payload.filters));
    yield put(createSnackbar('Batch File Generated Successfully'));
  } else {
    yield put(createSnackbar('Unable to Generate Batch File'));
  }

  isBatchRegenerationCompleted = [];
  yield put(changeReGenerateBatchFile(isBatchRegenerationCompleted));
}

export function* watchBatchFileAuditStatus() {
  yield takeLatest(GenelcoBatchFileActionType.REAUDIT_BATCH_FILE, reAuditBatchFileSaga);
}

export function* reAuditBatchFileSaga(action: ReturnType<typeof reAuditBatchFile>) {
  var {isBatchReAuditCompleted} = yield select((state: ReducerState) => state.genelcoBatchFileManagementState);
  isBatchReAuditCompleted.push(action.payload.processingCompletedDate);
  yield put(changeReAuditBatchFile(isBatchReAuditCompleted));
  const reAuditStatus: AsyncResult<boolean> = yield call(
    enrollmentFileApi.reAuditBatchFile,
    action.payload.processingCompletedDate
  );

  if (E.isRight(reAuditStatus)) {
    yield put(getGenelcoBatchFile(undefined, action.payload.filters));
    yield put(createSnackbar('Batch File Audit Completed Successfully'));
  } else {
    yield put(createSnackbar('Unable to Audit Batch File'));
  }

  isBatchReAuditCompleted = [];
  yield put(changeReAuditBatchFile(isBatchReAuditCompleted));
}
export function* watchProcessBrokerSpreadsheet() {
  yield takeLatest(EnrollmentFileActionType.PROCESS_BROKER_SPREADSHEET, processBrokerSpreadsheetSaga);
}

export function* processBrokerSpreadsheetSaga(action: ReturnType<typeof processBrokerSpreadsheet>) {
  const processingStatus: AsyncResult<boolean> = yield call(
    enrollmentFileApi.processBrokerSpreadsheet,
    action.payload.fileId,
    action.payload.processReasonId,
    action.payload.actionBy,
  );

  if (E.isRight(processingStatus)) {
    var {externalUploadQueueFilters} = yield select((state: ReducerState) => state.enrollmentFileProcessing);
    yield put(getExternalUploadQueue(undefined, externalUploadQueueFilters));
    yield put(createSnackbar('File Status Updated Sucessfully'));
  } else {
    yield put(createSnackbar('Unable to Update File status'));
  }
}

export function* watchFetchGetAccountNumbers() {
  yield takeLatest(EnrollmentFileActionType.GET_ACCOUNTNUMBERS, getAccountNumberSaga);
}


export function* getAccountNumberSaga() {
  const data: AsyncResult<any[]> = yield call(enrollmentFileApi.getAccountNumbers);
  const accountNumbersList: AutoCompleteList[] = [];
  if (E.isRight(data)) {
    let accountNumbersData = fromResult(data.right);
    accountNumbersData.Data.forEach(x => {
      const accountNumbers = {} as AutoCompleteList;
      accountNumbers.id = x;
      accountNumbers.label = x;
      accountNumbersList.push(accountNumbers);
    });

    yield put(changeAccountNumbers(fromResult(accountNumbersList)));
  } else {
    yield put(changeAccountNumbers(new ServerError('Unable to retrieve CaseNumbers.')));
  }
}

export function* getProductSaga() {
  const data: AsyncResult<any[]> = yield call(enrollmentFileApi.getAllProduct);
  const productTypeList: AutoCompleteList[] = [];

  if (E.isRight(data)) {
    let productTypeData = fromResult(data.right);
    productTypeData.Data.forEach(x => {
      const productTypes = {} as AutoCompleteList;
      productTypes.id = x;
      productTypes.label = x;
      productTypeList.push(productTypes);
    });

    yield put(changeProducts(fromResult(data.right)));
  } else {
    yield put(changeProducts(new ServerError('Unable to retrieve Products.')));
  }
}

export function* watchFetchGetProductTypes() {
  yield takeLatest(EnrollmentFileActionType.GET_PRODUCTS, getProductSaga);
}

export const getExternalUploadDetailQueue = (action: ReturnType<typeof getExternalUploadDetailsQueue>) => {
  let sort = action.routeParameters[1] as Sort;
  let column = '';
  let direction = '';
  if(sort !== undefined){
    column = sort.column;
    direction = sort.direction;
  }
    
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<ExternalUploadEnrollmentApplicationDetails>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getExternalUploadDetailsQueue(action.routeParameters[0] as string, action.payload.filter, column, direction);
    },
  })(action.payload);
};
export function* watchFetchGetExternalUploadDetailsQueue() {
  yield takeLatest(
    EnrollmentFileActionType.GET_EXTERNAL_UPLOAD_DETAILS_QUEUE,
    getPageApiCallGenerator(getExternalUploadDetailQueue, changeExternalUploadDetailsQueue)
  );
}

export default function*() {
  yield all([
    watchFetchEnrollmentFileDetails(),
    watchFetchEnrollmentFiles(),
    fetchEnrollmentMetricsSaga(),
    fetchFileFeedbackMetricsSaga(),
    fetchFilesNotProcessedMetricsSaga(),
    fetchFileProfileMetricsSaga(),
    fetchAccountProfileMetricsSaga(),
    fetchFileTrackingMonitorMetricsSaga(),
    watchFetchEnrollmentFileRejects(),
    watchFetchEnrollmentFileRejectByCaseRequestId(),
    watchFetchEnrollmentFileRejectDetails(),
    watchFetchGetEnrollmentFileRejectsEmail(),
    watchFetchSendEnrollmentFileRejectsEmail(),
    watchAuditEnrollmentFileRejectsAttachmentDownload(),
    watchFetchEnrollmentFileRejecEmailHistory(),
    watchFetchFilesNotProcessedReport(),
    watchFetchGetEnrollmentFileStatus(),
    watchFetchEnrollmentFileApplicationDetails(),
    watchFetchEnrollmentFileApplicationProcessingDetails(),
    watchFetchEnrollmentFileAWDHistoryDetails(),
    watchFetchUploadEnrollmentApplications(),
    watchUploadEmployerProfiles(),
    watchFetchGetEnrollmentApplicationsMetaData(),
    watchFetchGetEmployerProfileUploadData(),
    watchGetAllowedEnrollmentApplicationTemplates(),
    watchsaveUsersAgreementAcknowledgment(),
    watchFetchGetEnrollmentFileAudit(),
    watchUpdateEnrollmentFileRejectDetails(),
    watchFetchGetEnrollmentFileAuditDetail(),
    watchGetEnrollmentFileRecordValidation(),
    watchFetchGetLifeCycleReportChartDetails(),
    watchFetchProcessingAccuracyChartDetails(),
    watchUpdateEnrollmentFileStatus(),
    watchBrokerSpreadsheetCancelStatus(),
    watchFetchDaysToCompleteTurnAroundChartDetails(),
    watchFetchGetTotalRecordsChartDetails(),
    watchFetchGetEnrollmentApplicationsDetails(),
    watchFetchgetEnrollmentFileDetailsByCaseRequestId(),
    watchFetchgetEnrollmentFileApplicationDetail(),
    watchFetchGetExternalUploadQueue(),
    watchFetchGetFileVolumeChartDetails(),
    watchFetchGetEsrTotalRecordsChartDetails(),
    watchFetchGetEmployers(),
    watchFetchGetFileUploadsInProgress(),
    watchFetchgetBrokerSpreadsheetUploadsMetricsSaga(),
    watchFetchGetEnrollmentFileErrorDetails(),
    watchFetchgetApplications(),
    watchUpdateEnrollmentFileGenelcoStatus(),
    watchFetchGenelcoBatchFile(),
    watchBatchFileGenerationStatus(),
    watchBatchFileAuditStatus(),
    watchProcessBrokerSpreadsheet(),
    watchFetchGetAccountNumbers(),
    watchFetchGetProductTypes(),
    watchFetchGetExternalUploadDetailsQueue(),
  ]);
}
